import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  facebookIcon,
  googleIcon,
  ForgotPasswordCover,
  logo,
  BackwardArrow,
  ArrowUpRightBlue,
} from "../../constant/imagePath";
import { Button } from "../../stories/Button/Button";
import { Input } from "../../stories/Input/Input";
import classes from "./ResetPasswordPage.module.css";
import { BeforeLoginHeader } from "../../stories/BeforeLoginHeader/BeforeLoginHeader";
import CallMadeIcon from "@mui/icons-material/CallMade";
import { useHistory } from "react-router-dom";
import { PasswordStrengthCheck } from "../../stories/PasswordStrengthCheck/PasswordStrengthCheck";
import { toast } from "react-toastify";
import Colors from "../../stories/assets/Colors";
import Fonts from "../../stories/assets/Fonts";
import { isMobileViewHook } from "../../CustomHooks/isMobileViewHook";
import { MobileHeader } from "../../stories/MobileHeader/MobileHeader";
import { LinkButtonWithIcon } from "../../stories/LinkButtonWithIcon/LinkButtonWithIcon";

const ResetPasswordPage = (props) => {
  const history = useHistory();

  // variables and states

  const [password, setPassword] = useState("");
  const [passValidation, setPassValidation] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const handleResetPasswordRequest = () => {
    if (passValidation) {
      toast.success("Password succesfully updated");
      setTimeout(() => {
        history.push({ pathname: "login" });
      }, 1500);
    } else {
      toast.warning(
        "Password Validation Failed Please Enter Password As Per Given Instruction!"
      );
    }
  };

  useEffect(() => {
    isMobileViewHook(setIsMobile);
  }, [window.innerWidth]);

  return (
    <div className={` ${[classes.ResetPasswordPage].join(" ")}`}>
      <div className={`container-fluid ${classes.container}`}>
        {isMobile ? (
          <MobileHeader
            isLogo={true}
            isAvatar={false}
            customStyle={{ padding: "0px " }}
          />
        ) : (
          <BeforeLoginHeader
            onClick={() => {
              history.push({ pathname: "welcome" });
            }}
            icon={logo}
            text1={"Don’t have an account?"}
            text2={"Get started"}
            goBackOnClick={() => history.goBack()}
          />
        )}

        <div className="g-0 row" style={{ height: "100%" }}>
          <div className="col-md-12">
            <div className="g-0 row">
              <div
                className={`p-0 col-md-6 ${[
                  classes.innerContainer,
                  classes.imageContainer,
                ].join(" ")}`}
              >
                <img
                  className="img-fluid d-block w-100 hvh-100"
                  src={ForgotPasswordCover}
                />
              </div>
              <div
                className={`col-md-6 ${[
                  classes.innerContainer,
                  classes.rightContainer,
                ].join(" ")}`}
              >
                <div className={classes.goBack}>
                  <LinkButtonWithIcon
                    leftIcon={BackwardArrow}
                    text={"Go back"}
                    iconStyle={{ marginRight: "16px" }}
                  />
                </div>
                <h3
                  className={` ${[classes.mainHeading].join(" ")}`}
                  style={{ ...Fonts.h3, color: Colors.neutralShadesOfNero }}
                >
                  Reset password
                </h3>
                <span className={` ${[classes.subText].join(" ")}`}>
                  Enter the email address you used when you joined and we’ll
                  send you instructions to reset your password.
                </span>
                <form className="col-md-12">
                  <Input
                    type={"password"}
                    label={"New Password"}
                    state={password}
                    setter={setPassword}
                  />
                  <div className={classes.passwordStrength}>
                    <PasswordStrengthCheck
                      value={password}
                      setIsAllow={setPassValidation}
                    />
                  </div>
                  <div className={classes.resetBtn}>
                    <Button
                      primary={true}
                      disabled={false}
                      size={"Large"}
                      label={"Reset password"}
                      onClick={() => {
                        handleResetPasswordRequest();
                      }}
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
          {/* Footer */}
          {/* Already have account Login for mobile  */}
          <div className={`col-sm-12 ${classes.footerContainer}`}>
            <div className={classes.dontHaveAccountForMobile}>
              <p
                style={{
                  ...Fonts.p2,
                  color: Colors.neutralShadesOfDimGray,
                }}
              >
                Don’t have an account?
              </p>
              <LinkButtonWithIcon
                primary={true}
                text={"Get Started"}
                rightIcon={ArrowUpRightBlue}
                iconStyle={{ margin: "0px" }}
                onClick={() => history.push("/welcome")}
              />
            </div>
          </div>

          {/*  */}
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
